import { useState, useEffect } from 'react';

interface SettingsProps {
  apiEndpoint: string;
}

interface Store {
  id: number;
  name: string;
  slug: string;
  domain: string;
  email: string;
  phone: string;
  promptpay_id: string;
  currency: string;
  lang: string;
}

export default function Settings({ apiEndpoint }: SettingsProps) {
  const [store, setStore] = useState<Store | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchStore();
  }, [apiEndpoint]);

  const fetchStore = async () => {
    try {
      const response = await fetch(`${apiEndpoint}/api/store?store_id=1`);
      const data = await response.json();
      setStore(data.store);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch store:', error);
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!store) return;
    setSaving(true);
    // TODO: Implement save API
    setTimeout(() => setSaving(false), 500);
  };

  if (loading) return <div className="card">Loading...</div>;

  return (
    <div>
      <h1>Settings</h1>

      <div className="card">
        <h2>Store Information</h2>
        <div style={{ display: 'grid', gap: '16px', maxWidth: '500px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>Store Name</label>
            <input
              type="text"
              value={store?.name || ''}
              onChange={(e) => setStore(s => s ? { ...s, name: e.target.value } : null)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>Email</label>
            <input
              type="email"
              value={store?.email || ''}
              onChange={(e) => setStore(s => s ? { ...s, email: e.target.value } : null)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>Phone</label>
            <input
              type="tel"
              value={store?.phone || ''}
              onChange={(e) => setStore(s => s ? { ...s, phone: e.target.value } : null)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>PromptPay ID</label>
            <input
              type="text"
              value={store?.promptpay_id || ''}
              onChange={(e) => setStore(s => s ? { ...s, promptpay_id: e.target.value } : null)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
            />
          </div>

          <button
            onClick={handleSave}
            disabled={saving}
            style={{
              marginTop: '10px',
              padding: '12px 24px',
              background: saving ? '#ccc' : '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontWeight: 500
            }}
          >
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>

      <div className="card">
        <h2>Agentation Integration</h2>
        <p style={{ marginBottom: '16px', color: '#666' }}>
          Visual feedback tool is active in development mode.
          Annotations are synced with your AI agent in real-time.
        </p>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <code style={{ background: '#f5f5f5', padding: '8px 12px', borderRadius: '6px' }}>
            Endpoint: http://localhost:4747
          </code>
          <code style={{ background: '#f5f5f5', padding: '8px 12px', borderRadius: '6px' }}>
            Status: Active
          </code>
        </div>
      </div>
    </div>
  );
}
